import ProjectItemSkeleton from '../WorkProjectsList/ProjectItem/ProjectItemSkeleton';
import './DescriptionSkeleton.scss';

const DescriptionSkeleton = () => {

  return (
    <div className="description__section__skeleton">

      <div className="desc__wrapper__skeleton">
        {[...Array(2)].map((_, index) => (
          <div key={index} className="desc__item__skeleton">
            <div className="desc__item__title__skeleton"></div>
            <div className='desc__item__text__wrapper__skeleton'>
              {[...Array(6)].map((_, index) => (
                <div key={index} className="desc__item__text__skeleton"></div>
              ))}
              <div className="desc__item__text__skeleton--primary"></div>
            </div>
            <div className='desc__item__text__wrapper__skeleton'>
              {[...Array(8)].map((_, index) => (
                <div key={index} className="desc__item__text__skeleton"></div>
              ))}
              <div className="desc__item__text__skeleton--primary"></div>
            </div>
          </div>
        ))}
      </div>

      <ProjectItemSkeleton position="right"/>


      <div className="desc__wrapper__skeleton">
        {[...Array(2)].map((_, index) => (
          <div key={index} className="desc__item__skeleton">
            <div className="desc__item__title__skeleton"></div>
            <div className='desc__item__text__wrapper__skeleton'>
              {[...Array(6)].map((_, index) => (
                <div key={index} className="desc__item__text__skeleton"></div>
              ))}
              <div className="desc__item__text__skeleton--primary"></div>
            </div>
            <div className='desc__item__text__wrapper__skeleton'>
              {[...Array(8)].map((_, index) => (
                <div key={index} className="desc__item__text__skeleton"></div>
              ))}
              <div className="desc__item__text__skeleton--primary"></div>
            </div>
          </div>
        ))}
      </div>

      <ProjectItemSkeleton position="left"/>
    </div>
  );
};

export default DescriptionSkeleton;